import { AlignItems, Box, Display, Heading1, JustifyContent } from '@gousto-internal/citrus-react'
import type {
  DashboardExperienceActionResponse,
  DashboardExperienceRootSectionItem,
} from '@library/api-dashboard-experience'
import React from 'react'

import { DashboardActionButton } from '../DashboardActionButton'
import { DownloadAppAction } from '../DownloadAppAction'
import { RafCampaignAction, RafStatusAction } from '../RafCampaignAction'
import { dashboardActionRoutes } from './dashboardActionRoutes'

export type DashboardExperienceActionClickHandler = (
  actionType: DashboardExperienceActionResponse['type'],
) => void

export const isRenderableDashboardExperienceItem = (item: DashboardExperienceRootSectionItem) => {
  if (item.type === 'page_title') {
    return true
  }

  if (item.type === 'action') {
    return Boolean(item.data.title && dashboardActionRoutes[item.data.type])
  }

  if (
    item.type === 'app_download_prompt' ||
    item.type === 'raf_progress_banner' ||
    item.type === 'raf_campaign_banner'
  ) {
    return true
  }

  return false
}

export const renderDashboardExperienceItem = (
  item: DashboardExperienceRootSectionItem,
  onActionClick: DashboardExperienceActionClickHandler,
) => {
  if (item.type === 'page_title') {
    return (
      <Box
        width="100%"
        minHeight={['52px', '40px']}
        display={Display.Flex}
        alignItems={AlignItems.Center}
        justifyContent={JustifyContent.FlexStart}
        paddingV={[3, 1]}
        paddingH={[3, 0]}
        data-testid="my-home-page-title-box"
      >
        <Heading1>{item.data.text}</Heading1>
      </Box>
    )
  }

  if (item.type === 'action') {
    return (
      <DashboardActionButton actionType={item.data.type} onClick={onActionClick}>
        {item.data.title}
      </DashboardActionButton>
    )
  }

  if (item.type === 'app_download_prompt') {
    return <DownloadAppAction downloadApp={item.data} />
  }

  if (item.type === 'raf_progress_banner') {
    return <RafStatusAction onActionClick={onActionClick} status={item.data} />
  }

  if (item.type === 'raf_campaign_banner') {
    return <RafCampaignAction campaign={item.data} onActionClick={onActionClick} />
  }

  return null
}
